import { Entity } from '../entity';
import { Widget } from './widget/widget';
import { AuditDetails } from '../entity';



export enum DashboardVisibility {
    Private = 'private',
    Public = 'public',
    Shared = 'shared'
}
export interface Dashboard extends Entity, AuditDetails {

    widgets: Widget[];

    refreshTime?: number;
    system?: boolean;
    sharedWith?: Entity[];
    visibility: DashboardVisibility;

}

export interface DashboardViewResponse {
    views: DashboardView[];
    selectedView: DashboardView;
}

export interface DashboardView {
    _id: string;
    name: string;
    visibility: DashboardVisibility;
    system?: boolean;
    isDefault?: boolean;
}